import { Component, OnInit } from "@angular/core";
import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { TokenizedConfigTemplate } from "src/app/config-template";

@Component({
	selector: "app-manage-templates",
	templateUrl: "./manage-templates.component.html",
	styleUrls: ["./manage-templates.component.scss"]
})
export class ManageTemplatesComponent implements OnInit {
	public templates: APIResults.ConfigTemplate[];
	public selectedTemplate: APIResults.ConfigTemplate;
	public rawTemplate: string;
	public newTemplate: string;
	public newTemplateDescription: string;
	private readonly emptyTemplate: APIResults.ConfigTemplate = {
		template_id: null,
		description: "<Create new template>",
		content: null,
	};

	constructor(public api: ApiService) { }

	ngOnInit() {
		this.UpdateTemplates();
	}

	async UpdateTemplates() {
		const templates = await this.api.GetAllTemplates();
		this.templates = [this.emptyTemplate, ...templates];
	}

	async templateChange(template: APIResults.ConfigTemplate) {
		this.rawTemplate = undefined;
		this.newTemplate = undefined;
		if (template.template_id !== null) {
			this.rawTemplate = await this.api.GetTemplateContent(template.template_id);
		}
	}

	async CreateTemplate() {
		try {
			const content = this.newTemplate;
			const template = new TokenizedConfigTemplate(content);
			template.GetIdentifiers();
			await this.api.AddTemplate(this.newTemplateDescription, content);
			await this.UpdateTemplates();
		} catch (err) {
			if (err.token) {
				err.message += " for token id: " + err.token.id;
				err.message += "\nToken content: " + err.token.originalText;
				err.message += "\nSection: " + err.token.section;
				err.message += "\nLine: " + err.token.line + ", Character: " + err.token.position;
			}
			throw err;
		}
	}

	async UploadTemplate() {
		const content = this.newTemplate;
		const template = new TokenizedConfigTemplate(content);
		template.GetIdentifiers();
		await this.api.UpdateTemplate(this.selectedTemplate.template_id, content);
	}

	async DeleteTemplate() {
		await this.api.DeleteTemplate(this.selectedTemplate.template_id);
		this.selectedTemplate = undefined;
		await this.UpdateTemplates();
	}
}
